import React from "react";

function FlagIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="19"
      fill="none"
      viewBox="0 0 16 19"
    >
      <path
        fill="#121"
        d="M1.125 18.25a.625.625 0 01-.625-.625V2.161a.937.937 0 01.465-.809C1.438 1.077 2.39.75 4.25.75c1.454 0 3.08.575 4.514 1.081 1.155.408 2.246.794 2.986.794a7.18 7.18 0 002.773-.566.703.703 0 01.977.647v8.569a.782.782 0 01-.469.715c-.34.15-1.582.635-3.281.635-.943 0-2.124-.279-3.375-.575-1.405-.332-2.858-.675-4.125-.675-1.44 0-2.177.218-2.5.356v5.894a.625.625 0 01-.625.625z"
      ></path>
    </svg>
  );
}

export default FlagIcon;
